import React from 'react';
import { PropTypes as PT } from 'prop-types';
import _map from 'lodash/map';
import DropdownComp from 'components/Dropdown/Dropdown';
import classes from './SourceDisplay.module.scss';

class AudioSourceDropdown extends React.Component {
  audioDropdownButton = open =>
    (<div className={`${classes.audioSelect} ${open ? classes.openSelect : ''}`} data-testid={this.props.dataTestId ? this.props.dataTestId : 'microphone-dropdown'}>
      {this.props.selectedAudioLabel}
    </div>);

  audioSourcesGenerator = () => (
    <ul className={classes.sourceMenu}>
      {_map(this.props.audioDevices, source => (
        <span key={source.deviceId} title={source.label} >
          <button
            onClick={() => this.props.selectAudioSource(source.deviceId,
              { video: this.props.defaultVideoSetting, audio: this.props.defaultAudioSetting })}
            data-testid={this.props.dataTestId ? `${this.props.dataTestId}-option` : 'microphone-dropdown-option'}
          >
            {source.label}
          </button>
        </span>
      ))}
    </ul>);

  render() {
    return (
      <DropdownComp
        buttonComponent={this.audioDropdownButton()}
        openButtonComponent={this.audioDropdownButton(true)}
        menuComponent={this.audioSourcesGenerator()}
        dropdownClassName={classes.sourceDropdown}
      />
    );
  }
}

AudioSourceDropdown.propTypes = {
  audioDevices: PT.array.isRequired,
  selectAudioSource: PT.func.isRequired,
  defaultAudioSetting: PT.bool.isRequired,
  defaultVideoSetting: PT.bool.isRequired,
  selectedAudioLabel: PT.string,
  intl: PT.object,
  dataTestId: PT.string
};

export default AudioSourceDropdown;
